module.exports = __webpack_public_path__ + "img/Icon-feather-edit-3.e5023d1d.svg";